import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import ReactPortal from "./index";
import Srcset from "../Srcset";
import { useSelector } from "react-redux";

export default function PopUp(props) {
  const [show, setShow] = useState(false);
  const isShopMenuOpen = useSelector((state) => state.header.isMenuVisible);
  const closeButtonRef = useRef(null); // Ref for the close button
  const previousFocusedElementRef = useRef(null); // Ref for the previously focused element
  const popupRef = useRef(null); //Ref for the pop-up wrapper

  const closeHandler = (e) => {
    setShow(false);
    props.onClose(false);
  };

  const isPWA = useSelector((state) => state.pwa.is_PWA);

  useEffect(() => {
    setShow(props.show);
  }, [props.show]);

  useEffect(() => {
    if (show) {
      // Set focus to the close button when the popup opens
      closeButtonRef.current?.focus();

      // Trap focus within the popup
      const getFocusableElements = () => {
        if(!popupRef.current) return [];
        return [
          closeButtonRef.current,
          ...Array.from(document.querySelectorAll('.popup [tabindex="0"], .popup button, .popup [href], .popup input, .popup select, .popup textarea')).filter((el) => !el.disabled),
        ]
      };

      let isTabbing = false; //Flag to check if the focus is due to tab key press

      const handleKeyDown = (event) => {
        if (event.key === 'Tab') {
          isTabbing = true;
          handleTabKey(event);
        }else if (event.key === 'Escape') {
          closeHandler();
        }
      };
  
      const handleTabKey = (event) => {
        const focusableElements = getFocusableElements();
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey) { // Shift + Tab
          if (document.activeElement === firstElement) {
            event.preventDefault();
            lastElement?.focus();
          }
        } else { // Tab
          if (document.activeElement === lastElement) {
            event.preventDefault();
            firstElement?.focus();
          }
        }
      };
  
      const handleFocus = (event) => {
        if(isTabbing){
          // Remove focusElement class from the previously focused element
          if (previousFocusedElementRef.current) {
            previousFocusedElementRef.current.classList.remove('focusElement');
          }
          // Add focusElement class to the currently focused element
          event.target.classList.add('focusElement');
          // Update the ref to the currently focused element
          previousFocusedElementRef.current = event.target;
        }
        isTabbing = false;
      };

      const handleMouseDown = () => {
        isTabbing = false;
      }
  
      //Add focus event listener to all focusable elements in the pop-up
      if(popupRef.current){
        popupRef.current.addEventListener('focusin', handleFocus);
      }
  
      window.addEventListener('keydown', handleKeyDown);
      window.addEventListener('mousedown', handleMouseDown);
  
      return () => {
        window.removeEventListener('keydown', handleKeyDown);
        window.removeEventListener('mousedown', handleMouseDown);
        // Clean up focus event listeners
        popupRef.current?.removeEventListener('focusin', handleFocus);
      };
    }
  }, [show]);
  

  var IconSrc = props.closeIcon ? "images/Icons/Chevron/large.svg" : "images/Icons/Cross/Large.svg";

  return (
    <>
      <ReactPortal wrapperId="react-portal-modal-container">
        <div className={`custom-popup ${props.wrapperClass}`}>
          <div
            style={{
              visibility: !isShopMenuOpen && (show || props.show) ? "visible" : (isShopMenuOpen && props.wrapperClass === 'quick-buy-popup' && (show || props.show) ? "visible" : (isShopMenuOpen && props.wrapperClass === 'size-guide-popup ' && isPWA && (show || props.show)
              ? "visible" 
              : "hidden")),
              opacity: !isShopMenuOpen && (show || props.show) ? "1" : (isShopMenuOpen && props.wrapperClass === 'quick-buy-popup' && (show || props.show) ? "1" :  (isShopMenuOpen && props.wrapperClass === 'size-guide-popup ' && isPWA && (show || props.show)
                ? "1" 
                : "")),
              zIndex: !isShopMenuOpen ? "9999" : (isShopMenuOpen && props.wrapperClass === 'quick-buy-popup' && (show || props.show) ? "9999" :  (isShopMenuOpen && props.wrapperClass === 'size-guide-popup ' && isPWA 
                ? "9999" 
                : ""))
            }}
            className={`overlay${isPWA ? " addBottomMargin_APPNav" : ""}`}
          >
            <div ref={popupRef} className={`${isPWA && props.wrapperClass === 'size-guide-popup' ? 'popup pwa-popup' : 'popup'}`}>
              <span className="close" onClick={closeHandler} ref={closeButtonRef} tabIndex={0}>
                <Srcset
                  id="popup-close-button"
                  svgFile={true}
                  src={IconSrc}
                  requirePath={true}
                  height="20"
                  width="20"
                  alt="cross"
                  className={props.closeBtnClass}
                />
              </span>
              <div className="content">{props.children}</div>
            </div>
          </div>
        </div>
      </ReactPortal>
    </>
  );
}

PopUp.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
